//发送查询fileId请求
import { useUserInfo } from "~/stores/user/userInfo";

export async function playSin(player: any, fileId: string, sectionId: number) {
  const obj = {
    url: RequestAPI.GET_PLAY_SIGN,
    body: {
      fileId: fileId,
      sectionId: sectionId
    }
  }

  //用户信息（添加水印用）
  const userInfoStore = useUserInfo();
  
  const { data } = await postRequired(obj);
  if (data.value) {
    if (data.value.code === 2000) {
      if (player.value) {
        player.value.loadVideoByID({
          fileID: data.value.data.fileId,
          appID: '1254318001',
          psign: data.value.data.pSign,
          plugins: {
            DynamicWatermark: {
              content: `${userInfoStore.getPhoneNumber}`,
              color: 'green'
            }
          },
          // 添加缓存策略
          hlsConfig: {
            maxBufferLength: 10, // 10s
            maxBufferSize: 1 * 1000 * 1000, // 1MB
          },
          licenseUrl:
            'https://license.vod2.myqcloud.com/license/v2/1254318001_1/v_cube.license',
            
        })
      } else {
        const Button = TCPlayer.getComponent('Button');
        const BigPlayButton = TCPlayer.getComponent('BigPlayButton');
        BigPlayButton.prototype.createEl = function () {
          var el = Button.prototype.createEl.call(this);
          let _html = '<button><svg t="1723602838823" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4262" width="64" height="64"><path d="M772.7 217.7a32.2 32.1 0 1 0 64.4 0 32.2 32.1 0 1 0-64.4 0Z" fill="#4D4D4D" p-id="4263"></path><path d="M415.8 679.9c5.9 0 11.5-1.6 16.2-4.5l231.1-134.6c10.9-5.2 18.5-16.3 18.5-29.2 0-11.9-6.4-22.3-16-27.8L439.7 352.2c-5.8-6.7-14.4-10.9-23.9-10.9-17.6 0-31.8 14.4-31.8 32.1 0 0.6 0 1.2 0.1 1.8l-0.4 0.2 0.5 269c-0.1 1.1-0.2 2.2-0.2 3.4 0 17.7 14.3 32.1 31.8 32.1z" fill="#4D4D4D" p-id="4264"></path><path d="M909.8 306.6c-5.4-10.5-16.3-17.8-28.9-17.8-17.8 0-32.2 14.4-32.2 32.1 0 6 1.7 11.7 4.6 16.5l-0.1 0.1c26.9 52.4 42.1 111.8 42.1 174.7 0 211.6-171.6 383.2-383.2 383.2S128.8 723.8 128.8 512.2 300.4 129.1 512 129.1c62.5 0 121.5 15 173.6 41.5l0.2-0.4c4.6 2.6 10 4.1 15.7 4.1 17.8 0 32.2-14.4 32.2-32.1 0-13.1-7.9-24.4-19.3-29.4C653.6 81.9 584.9 64.5 512 64.5 264.7 64.5 64.3 265 64.3 512.2S264.7 959.9 512 959.9s447.7-200.4 447.7-447.7c0-74.1-18-144-49.9-205.6z" fill="#4D4D4D" p-id="4265"></path></svg></button>';

          el.appendChild(TCPlayer.dom.createEl('div', {
            className: 'vjs-button-icon',
            innerHTML: _html,
          }));
          return el;
        };

        player.value = TCPlayer('video-container', {
          fileID: data.value.data.fileId,
          appID: '1254318001',
          psign: data.value.data.pSign,
          licenseUrl:
            'https://license.vod2.myqcloud.com/license/v2/1254318001_1/v_cube.license',
          plugins: {
            DynamicWatermark: {
              content: `${userInfoStore.getPhoneNumber}`,
              color: 'green'
            }
          },
          // 添加缓存策略
          hlsConfig: {
            maxBufferLength: 10, // 10s
            maxBufferSize: 1 * 1000 * 1000, // 1MB
          },
          controlBar: {
            playbackRateMenuButton: false,
            QualitySwitcherMenuButton: false,
            // currentTimeDisplay: false
          }
        });
      }
    }
  }
}

